import { Stack } from '@fluentui/react'

import styles from "../chat/Chat.module.css";

import { TalkingHead } from "../../components/TalkingHead";
import React from 'react';
interface AvatarProps {
  fullScreen?: boolean;
  scale: number;
  onFirstFrame?: () => void;
  firstFrameReady: boolean;
  keyboardHeight: number;
}

const Avatar = React.memo(({ fullScreen, scale, onFirstFrame, firstFrameReady, keyboardHeight }: AvatarProps ) => {
  return (
    <Stack 
      horizontal 
      className={`${styles.avatarWrapper} ${firstFrameReady ? styles.visible : ""}`}
      flex-wrap
    >
      <TalkingHead keyboardHeight={keyboardHeight} fullScreen={fullScreen} scale={scale} onFirstFrame={onFirstFrame}/>
    </Stack>
  );
});

export default Avatar;
